$(function() {
   
    //topKvSlick
    $('.topKvSlick').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true
    });
    
    //weather
	var weatherArray = [];
	$.getJSON("https://sfapi.jp/api/nap/weather.json?v=" + Math.random(), getFuncWeather);
	function getFuncWeather(myData){
		var leng = myData.list.length;
		for(var i = 0; i < leng; i++) {
			weatherArray[i] = new Array();
			var name = myData.list[i].id;
			var temp = myData.list[i].main.temp;
			var id = myData.list[i].weather[0].id;
			var weather = myData.list[i].weather[0].main;
			weatherArray[i][0] = name;
			weatherArray[i][1] = Math.floor(temp);
			weatherArray[i][2] = id;
			weatherArray[i][3] = weather;
		}
		console.log(weatherArray);
		initTopItem();
	}
	function initTopItem(){
		var weather = weatherArray[0][1];
		var icon = weatherArray[0][2];
		var weatherName = weatherArray[0][3];
		if(icon == '800') {
			var classed = 'sun';
		} else if(icon == '803') {
			var classed = 'suncloud';
		} else if(icon == '741' | icon == '500' | icon == '501') {
			var classed = 'rain';
		} else if(icon == '801' | icon == '802' | icon == '803' | icon == '804') {
			var classed = 'cloud';
		} else if(icon == '600') {
			var classed = 'snow';
		} else {
			var classed = 'cloud';
		}
		$('.topKv__movie--detail--weather').addClass(classed);
		$('.weather--text').html(weatherName);
		var countElm = $('.count'),
			countSpeed = 40,
			countMax = Number(weather);
		
		var self = $('.weather--temperature');
		self.text(countMax);
	}
	
	$('.topKv__movie--detail--date span:eq(0)').html( ('00' + moment().date()).slice( -2 ) );
	var monthID = moment().month();
	$('.topKv__movie--detail--date span:eq(1)').html( monthLabel[monthID]);
	$('.topKv__movie--detail--date span:eq(2)').html(moment().year());
	setTimeout(function() {
		$('.topKv').addClass('js--loadingRemove');
		initNap();
	},1000);
	//'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCF85opB4_2t9mzlBdFm8IaQ&type=video&eventType=live&key=AIzaSyAQxi2oLCkZldD4KLnO8LuxNBCTHEb2VEw'
	
});


/*$.ajax({
  type: 'GET',
  url: 'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCF85opB4_2t9mzlBdFm8IaQ&maxResults=5&order=date&type=video&key=AIzaSyAQxi2oLCkZldD4KLnO8LuxNBCTHEb2VEw',
  datatype: 'json',
  success: function(json){
	var num = json.items.length;
	var count = 0;
	for(var i = 0; i < num ; i++){
		var ID = json.items[i].id.videoId;
		var status = json.items[i].snippet.liveBroadcastContent;
		if(status === 'live') {
			videoList[count] = new Array();
			videoList[count][0] = ID;
			videoList[count][1] = status;
			count++;
		}
	}
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	videoIndex = Math.floor(Math.random() * videoList.length);
	  var date_obj = new Date();
	  var hours = date_obj.getHours();
	  
	  if(hours >= 18 && hours < 22 ) {
		  videoIndex = 0;
		  videoList[0][0] = 'rcvmg1D2Nt8';
	  } else if(hours >= 0 && hours <= 6) {
		  videoIndex = 0;
		  videoList[0][0] = 'ZCBECoj8BP8';
	  } else if(hours >= 22 && hours <= 24) {
		  videoIndex = 0;
		  videoList[0][0] = 'ZCBECoj8BP8';
	  }
	  console.log(hours,videoList[videoIndex][0])
  },
  error: function(){
	alert('error');
  }
});*/
//動画ID取得
var videoList = [
	['rcvmg1D2Nt8','live'],
	['titskhtTzds','live'],
	['mBxBNb18kGw','live']
],
	videoIndex;
videoIndex = 0; //Math.floor(Math.random() * videoList.length);
  var date_obj = new Date();
  var hours = date_obj.getHours();

  if(hours >= 18 && hours < 22 ) {
	  videoIndex = 0;
	  videoList[0][0] = 'rcvmg1D2Nt8';
  } else if(hours >= 0 && hours < 6) {
	  videoIndex = 0;
	  videoList[0][0] = 'ZCBECoj8BP8';
  } else if(hours >= 6 && hours < 9) {
	  videoIndex = 0;
	  videoList[0][0] = 'rcvmg1D2Nt8';
  } else if(hours >= 22 && hours <= 24) {
	  videoIndex = 0;
	  videoList[0][0] = 'ZCBECoj8BP8';
  }
videoList[0][0] = 'ZCBECoj8BP8';
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];



firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


//videoカメラ設定
var player;
function onYouTubeIframeAPIReady() {
	videoList[0][0] = 'ZCBECoj8BP8';
	console.log(videoList[videoIndex][0],videoIndex)
  player = new YT.Player('player', {
    height: '597',
    width: '1060',
    videoId: videoList[videoIndex][0],
	playerVars: {
		rel   : 0,
        controls: 1,
        showinfo: 0,
		playsinline: 1
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}

// 再生が可能になると呼び出されます。
function onPlayerReady(event) {
	event.target.mute();
	event.target.playVideo();
	event.target.setPlaybackQuality('hd1080');
	resize.top();
	setTimeout(function() {
		setTime();
		$('.topKv').addClass('js--movieShow');
		$('.topKv').addClass('js--textShow');
	},3000);
}

function onPlayerStateChange(event) {
   if (event.data == YT.PlayerState.ENDED) {
    event.target.playVideo();
  }
}
//現在時刻
var requestAnimationFrame = window.requestAnimationFrame || 
			window.mozRequestAnimationFrame ||
						   window.webkitRequestAnimationFrame || 
			window.msRequestAnimationFrame;
window.requestAnimationFrame = requestAnimationFrame;
var cancelAnimationFrame = window.cancelAnimationFrame || 
			window.mozcancelAnimationFrame ||
						   window.webkitcancelAnimationFrame || 
			window.mscancelAnimationFrame;
window.cancelAnimationFrame = cancelAnimationFrame;
var monthLabel = ['January','February','March','April','May','June','July','August','September','October','November','December'],
	slideInterval;

function setTime() {
	$('.topKv__movie--detail--date span:eq(0)').html( ('00' + moment().date()).slice( -2 ) );
	var monthID = moment().month();
	$('.topKv__movie--detail--date span:eq(1)').html( monthLabel[monthID]);
	$('.topKv__movie--detail--date span:eq(2)').html(moment().year());

	$('.topKv__movie--detail--time span:eq(0)').html( ('00' + moment().hour()).slice( -2 ) );
	$('.topKv__movie--detail--time span:eq(1)').html( ('00' + moment().minutes()).slice( -2 ) );
	$('.topKv__movie--detail--time span:eq(2)').html( ('00' + moment().second()).slice( -2 ) );
	slideInterval = window.requestAnimationFrame(setTime);

}


function initNap() {
	$('.topKv__movie--detail--date span:eq(0)').html( ('00' + moment().date()).slice( -2 ) );
	var monthID = moment().month();
	$('.topKv__movie--detail--date span:eq(1)').html( monthLabel[monthID]);
	$('.topKv__movie--detail--date span:eq(2)').html(moment().year());
	
	const DURATION = 2;
	const el = {
	  count: document.querySelector('.js--hour')
	}
	const from = parseInt(0, 10)
	const to = parseInt(Number(moment().hour()), 10)
	let obj = {count: from}

	gsap.to(obj, DURATION, {
		count: to,
		ease: Power3.easeInOut,
		onUpdate: () => {
		  el.count.textContent = ( '00' + Math.floor(obj.count) ).slice( -2 )
		}
	});

	const el2 = {
	  count: document.querySelector('.js--min')
	}
	const from2 = parseInt(0, 10)
	const to2 = parseInt(Number(moment().minutes()), 10)
	let obj2 = {count: from2}

	gsap.to(obj2, DURATION, {
		count: to2,
		ease: Power3.easeInOut,
		onUpdate: () => {
		  el2.count.textContent = ( '00' + Math.floor(obj2.count) ).slice( -2 )
		}
	});

	const el3 = {
	  count: document.querySelector('.js--sec')
	}
	const from3 = parseInt(0, 10)
	const to3 = parseInt(Number(moment().second()), 10)
	let obj3 = {count: from3}

	gsap.to(obj3, DURATION, {
		count: to3,
		ease: Power3.easeInOut,
		onUpdate: () => {
		  el3.count.textContent = ( '00' + Math.floor(obj3.count) ).slice( -2 )
		}
	});
	
}

//resize
 var headerH = $('header').outerHeight();
function setTopSize() {}
setTopSize.prototype.top = function() {
	var winW = $(window).width(),
		winH = $(window).outerHeight(),
		wh = $('.topKv__movie').width() / $('.topKv__movie').height(),
		whYoutube = 9 / 16 
	$('.topKv .topKv__movie').css({height : winH - headerH});
	
	if(wh <= whYoutube) {
		$('.topKv__movie iframe').css({ height: $('.topKv__movie').height()* whYoutube, width: $('.topKv__movie').height() });
	} else {
		console.log(whYoutube,wh)
		$('.topKv__movie iframe').css({ width: $('.topKv__movie').width() / whYoutube, height: $('.topKv__movie').width()});
	}
}
var resize = new setTopSize();
$(window).resize(function() {
	resize.top();
});
resize.top();